module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rochelle Alers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Hailed by readers and booksellers alike as one of today's most popular African-American authors of women's fiction, Ms. Alers is a regular on bestsellers list, and has been a recipient of numerous awards, including the Vivian Stephens Award for Excellence in Romance Writing and a Zora Neale Hurston Literary Award.  Visit her Web site "), _c('a', {
    attrs: {
      "href": "http://www.rochellealers.com"
    }
  }, [_vm._v("www.rochellealers.com")]), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/X1zxX2/tc-custom/9781426864223.jpg?1740451410286",
      "alt": "This image is the cover for the book Butterfly"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Butterfly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("After meeting her dream man and hoping to settle down, a supermodel discovers beauty has a price in this African American romance.")]), _c('br'), _c('br'), _vm._v("From her first high-heeled step onto a Paris runway, supermodel Seneca Houston has been a sensation. Ever since, she’s been surrounded by couture clothes, glittering celebrities—and the constant glare of the paparazzi. She’s become muse to designer Luis Navarro, who christens her Butterfly. Now, at thirty-three, Seneca wants the only thing that seems out of reach—a husband, children and a normal life."), _c('br'), _c('br'), _vm._v("When her agent offers his secluded villa as a hideaway, Seneca finds both tranquillity and Dr. Eliot Rollins, a renowned plastic surgeon who is quickly captivated by the intelligent woman behind the breathtaking face. But when Seneca decides to retire from modeling, there are repercussions she never expected. Some people want Butterfly to stay trapped in the spotlight, even if it destroys her. Surrounded by tabloid scandal, grasping relatives and friends with hidden agendas, Seneca wonders if anything can be trusted—even her own heart. . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0